import { Button, Image } from '@chakra-ui/react'
import { mdiAlertCircleOutline } from '@mdi/js'
import { useAtom } from 'jotai'
import { Trans, useTranslation } from 'react-i18next'

import Body from '@/components/body/Body'
import { Box } from '@/components/ui/box'
import { Container } from '@/components/ui/container'
import { Flex } from '@/components/ui/flex'
import { Link } from '@/components/ui/link'
import { Text } from '@/components/ui/typography'
import { HEADER_HEIGHT } from '@/constants'
import { appEnvName } from '@/env/vars.ts'
import useColorModeValue from '@/hooks/useColorModeValue'
import { type TI18nKey } from '@/i18n'
import EmptyState from '@/pages/components/tasksApprovals/mainContent/emptyState'
import { networkErrorAtom } from '@/store/app/NetworkErrorAtom.ts'

const NetworkError = () => {
    const { t } = useTranslation()
    const [networkErrorType] = useAtom(networkErrorAtom)

    const appEnv = appEnvName === 'prod' ? '' : appEnvName

    return (
        <>
            <Box p={4} className={`mainHeader ${appEnv} ${appEnv && 'lower-env-bg'}`}>
                <Flex alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center">
                        <Box flexShrink={0}>
                            <a href="/">
                                <Image src="/assets/GSK-logo.png" alt="GSK Logo" mr="16px" ml="16px" height="36px" width="120px" />
                            </a>
                        </Box>
                        <Box alignItems="center" display="flex">
                            <Text fontSize="14x" letterSpacing="0.25px" lineHeight="20px">
                                {t('global.header.title')}
                                {appEnv && (
                                    <Text
                                        as="span"
                                        color="orangered"
                                        display="inline"
                                        textTransform="uppercase"
                                        fontWeight="bold"
                                    >{` (${appEnv} Environment)`}</Text>
                                )}
                            </Text>
                        </Box>
                    </Box>
                </Flex>
            </Box>
            <Container
                maxW="100%"
                h={[
                    `calc(100% - ${HEADER_HEIGHT.mobile})`,
                    `calc(100% - ${HEADER_HEIGHT.mobile})`,
                    `calc(100% - ${HEADER_HEIGHT.desktop})`,
                ]}
                display="flex"
                flexDirection="column"
                flexGrow="1"
                padding="24px"
                backgroundColor={useColorModeValue('var(--chakra-colors-surface-light)', 'black')}
            >
                <Body>
                    <Box maxW="800px" margin="auto">
                        <EmptyState
                            title={t(`global.error.${networkErrorType}.title` as TI18nKey)}
                            message={
                                <Trans
                                    i18nKey={`global.error.${networkErrorType}.message` as TI18nKey}
                                    components={{
                                        bold: <strong />,
                                        a: (
                                            <Link
                                                href="https://servicenow.gsk.com/now/nav/ui/classic/params/target/incident.do%3Fsys_id%3D-1%26sysparm_query%3Dactive%253dtrue%26sysparm_stack%3Dincident_list.do%253fsysparm_query%253dactive%253dtrue%26sysparm_view%3D%26sysparm_view_forced%3Dtrue"
                                                isExternal
                                                textDecoration="underline"
                                            />
                                        ),
                                    }}
                                />
                            }
                            icon={mdiAlertCircleOutline}
                            iconColor="var(--chakra-colors-status-error)"
                        >
                            <Button asChild mt="24px" textTransform="uppercase" variant="primary">
                                <a href="/"> {t(`global.error.${networkErrorType}.button` as TI18nKey)}</a>
                            </Button>
                        </EmptyState>
                    </Box>
                </Body>
            </Container>
        </>
    )
}

export default NetworkError
